import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-all-closed-tickets',
  templateUrl: './all-closed-tickets.component.html',
  styleUrls: ['./all-closed-tickets.component.css']
})
export class AllClosedTicketsComponent implements OnInit {
  u:any={};

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    //this.TotalClosedTickets();
  }

  TotalClosedTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.totalClosedTickets(this.u.FromDate,this.u.ToDate)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

Print = function () {
  window.print()
}
}



// WEBPACK FOOTER //
// ./src/app/reports/all-closed-tickets/all-closed-tickets.component.ts